// this is a class to return a message to the calling function
export default class returnMessageClass {
  success; // true or false
  message; // a message string to the user
  origin; // the function name that called this class
  error; // the error returned from the called function
  data; // data to be returned
  constructor(origin) {
    this.success = false;
    this.message = "initial";
    this.origin = origin;
    this.error = null;
    this.data = null;
  }
}
